import doAuthRedirectForMini from './doAuthRedirectForMini';

export default function handleAuthError(
    loc: Location,
    onAuthFailure?: (claimsChallenge: string | null) => boolean,
    headers?: Headers
) {
    let isAuthErrorHandled: boolean = false;

    if (onAuthFailure) {
        const claimsChallenge = headers ? headers.get('WWW-Authenticate') : null;
        isAuthErrorHandled = onAuthFailure(claimsChallenge);
    }

    if (isAuthErrorHandled) {
        return;
    }

    doAuthRedirectForMini(loc, headers);
}
